import {useQuery} from 'react-query';
import {getCardDetail} from '.';

const useGetCategoriesCardDetail = () => {
  const useGetCardDetail = (guid?: string, inputGroup?: string) => {
    const {data, isLoading, refetch} = useQuery(
      ['get-cart-detail-list', guid, inputGroup],
      getCardDetail,
    );
    return {
      data,
      isLoading,
      refetch,
    };
  };

  return {useGetCardDetail};
};

export default useGetCategoriesCardDetail;
